exports = module.exports = require("../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-nav-bars-shared-nav-bar-v2--nav-bar-module-logoutButton{margin-top:auto}", ""]);

// exports
exports.locals = {
	"logoutButton": "src-components-nav-bars-shared-nav-bar-v2--nav-bar-module-logoutButton"
};